
import {
  IconCycle,
  IconGlasses,
  IconLeaf,
  IconThumbsUpOutlined,
  RevButton,
} from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'
import IllustrationEarth from '@core/illustrations/IllustrationEarth.svg'
import { productRenewedImpactModalFetch } from '@http/endpoints'

import ContentRowModal from '../ContentRowModal'

const ICONS = {
  IconLeaf,
  IconCircle: IconCycle,
  IconThumbsUp: IconThumbsUpOutlined,
  IconGlasses,
}

const ILLUSTRATIONS = {
  IllustrationEarth,
}

export default {
  components: {
    ContentRowModal,
    RevButton,
  },
  data() {
    return {
      content: {},
      isLoading: true,
      hasError: false,
    }
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
    }),

    modalName: () => MODAL_NAMES.PRODUCT.RENEWED_IMPACT,

    modalTitle() {
      return this.content.title
    },
    links() {
      return this.content.links
    },
    shouldDisplayLinks() {
      return !isEmpty(this.links)
    },
    renewedImpact() {
      return this.content.paragraphs?.map(({ icon, title, text }) => ({
        icon: ICONS[icon],
        labels: [text],
        title,
      }))
    },
    illustration() {
      return ILLUSTRATIONS[this.content.image]
    },

    productId() {
      return this.$route.params.uuid
    },
  },
  methods: {
    async fetchRenewedImpact() {
      try {
        const { payload } = await this.$store.dispatch('http/request', {
          request: productRenewedImpactModalFetch,
          pathParams: { productId: this.productId },
        })

        this.content = { ...payload }
        this.isLoading = false
      } catch {
        this.isLoading = false
        this.hasError = true
      }
    },

    onModalClose() {
      this.isLoading = true
      this.hasError = false
    },
  },
}
